export default "__VITE_ASSET__84fa4150__"